module.exports = __webpack_public_path__ + "img/logo.3105f7bd.svg";